module.exports = __webpack_public_path__ + "static/img/3bg_15.c7f94ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_15.png
// module id = 691
// module chunks = 1